const allDetails = document.querySelectorAll('.room-plan__accordion');
const allSummary = document.querySelectorAll('.room-plan__accordion-title');

allSummary.forEach((item) => {
  item.addEventListener('click', () => {
    allDetails.forEach((details) => details.removeAttribute('open'));
  });
});

const allButton = document.querySelectorAll('.button-plan');
allButton.forEach((item) => {
  item.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.room-plan__modal').classList.toggle('open');
    document.querySelector('.room-plan__overlay').classList.toggle('open');
  });
});
